<!-- <div class="d-flex bg-body-tertiary INN-h100vh">
    <main class="form-signin w-100 m-auto rounded-4 card shadow">  
      <form class="bs-secondary-color needs-validation" novalidate>
        
        <img class="mb-4" src="../../../assets/svg/DDF-Logo.svg" alt="">
        
        <h1 class="h3 mb-3 fw-normal">Iniciar Sesión</h1>
   -->
        <!-- <div class="form-floating">
          <input type="email" class="form-control" [(ngModel)]="email" name="email" placeholder="name@example.com" required>
          <label for="floatingInput">Usuario</label>
        </div>
  
        <div class="form-floating">
          <input type="password" class="form-control" [(ngModel)]="password" name="password" placeholder="Password" required>
          <label for="floatingPassword">Contraseña</label>
        </div> -->
        
        <!-- <button class="btn btn-primary w-100 py-2 INN-color-white INN-color-white-hover" type="submit" (click)="login()">Iniciar Sesión
        </button>
        
      </form>
    </main>
  
  
  </div> -->

  <div class="d-flex bg-body-tertiary INN-h100vh">
    <main class="form-signin w-100 m-auto rounded-4 card shadow m-5">
      <img  class="mb-2 ms-2 mt-4 col-6 text-center" src="../../../assets/svg/DDF-Logo.svg" alt="">
      <div class="card border-0">
        <img src="../../../assets/svg/img-login.jpg" class="card-img-top img-fluid mt-1" alt="...">
        <div class="card-body">
          <h1 class="h3 mt-3 mb-4 fw-normal text-center text-primary">Bienvenido</h1>
          <button class="btn btn-primary w-100 py-2 INN-color-white INN-color-white-hover mb-3" type="submit" (click)="login()">Iniciar Sesión</button>
        </div>
      </div>
    </main>
  </div>